// visibleOrgs — THE ONE RULE for which of the person's orgs a list OFFERS.
//
// Every account owns one personal org (server rule, Nika 2026-10-25: "the
// personal org stays in the background"). POB persona round 5: a person who
// signed up as a team saw two orgs — the team and an extra "My workspace"
// (the personal org, made empty with the default name). Nika 2026-10-31
// (STATUS r122 option 1): the server marks each personal-org row of /auth/me
// `organizations[]` with `hasContent` (true when that org holds any project,
// app or workspace content), and the client hides an empty one.
//
// Hidden = a row with ALL of:
//   - `type === 'personal'` and `role === 'owner'` — the person's OWN personal
//     org. Someone else's personal org reached through a workspace grant
//     (role 'contributor') is a real place they were invited to; it stays.
//   - `hasContent === false` — the server says it is empty. A row WITHOUT the
//     field (a server that predates it) keeps the old behaviour: shown. Only
//     a real boolean `false` hides.
//   - the list also holds a row that is not personal (a team org, or a legacy
//     claims row without `type`). A solo account keeps its only org, so a
//     non-empty list never comes back empty.
//   - not named in `opts.keep` (ids or slugs) — the org the person is IN, the
//     one an in-tab switch is moving to, or the one the URL names. Hiding is
//     for lists and pickers only; a deep link to the personal org must still
//     resolve and show where the person is.
//
// Callers: the org switcher's `rawOrgs` reads (components/AppOrgSwitcher.js),
// the Studio link fallback (components/AppNavbar.js), the shell's bare `/w`
// hub (workspace pages/workspaceHub.js, through el.call).
//
// Pure: reads only its arguments (`this` is the calling element under
// el.call and is not read). Returns the SAME array when nothing is hidden.
export function visibleOrgs(orgs, opts) {
  const list = Array.isArray(orgs) ? orgs : []
  if (!list.length) return list
  const keep = new Set(
    (opts && Array.isArray(opts.keep) ? opts.keep : [])
      .filter((v) => v !== null && v !== undefined && v !== '')
      .map(String)
  )
  const hasTeam = list.some((o) => !!o && o.type !== 'personal')
  if (!hasTeam) return list
  const kept = (o) =>
    keep.has(String(o.id || o._id || '')) || (!!o.slug && keep.has(String(o.slug)))
  const hidden = (o) =>
    !!o && o.type === 'personal' && o.role === 'owner' && o.hasContent === false && !kept(o)
  if (!list.some(hidden)) return list
  return list.filter((o) => !hidden(o))
}
